export default __webpack_public_path__ + "static/Speedstick-0eff7f98a5d00e88b102671433864c95.png";